import * as amplitude from '@amplitude/analytics-browser';

const AMPLITUDE_KEY = 'a50edddde55ea0b42955c5db7f97d44a';

export const Events = {
  APP_LAUNCHED: 'App Launched',
  SEARCH_PERFORMED: 'Search Performed',
  SEARCH_BLOCKED: 'Search Blocked',
  LOGIN_COMPLETED: 'Login Completed',
  RESULT_CLICKED: 'Result Clicked',
  PAYWALL_SHOWN: 'Paywall Shown',
  PAYWALL_IMPRESSION: 'Paywall Impression',
  PAYMENT_BUTTON_CLICKED: 'Payment Button Clicked',
  CHECKOUT_STARTED: 'Checkout Started',
  CHECKOUT_LOGIN_REQUIRED: 'Checkout Login Required',
};

let initialized = false;

export function initAnalytics() {
  if (initialized || typeof window === 'undefined') return;
  try {
    amplitude.init(AMPLITUDE_KEY, {
      autocapture: {
        attribution: true,
        pageViews: true,
        sessions: true,
        formInteractions: true,
        elementInteractions: true,
      },
    });
    initialized = true;
  } catch (error) {
    console.error('analytics init failed', error);
  }
}

export function track(eventName, properties = {}) {
  if (!initialized) return;
  try {
    amplitude.track(eventName, properties);
  } catch (error) {
    console.error('analytics track failed', error);
  }
}

export function identifyUser(user) {
  if (!initialized || !user) return;
  try {
    amplitude.setUserId(user.uid);
    amplitude.identify(new amplitude.Identify().set('is_anonymous', Boolean(user.isAnonymous)));
  } catch (error) {
    console.error('analytics identify failed', error);
  }
}
